import type { AddressLink } from '@festina/legalentity-general-types/legalentity'
import { typeUtils, type ValidatedKey } from '@festina-life/core'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'
import { useField } from 'formik'

import { useComponent, useHook } from '../../lenteHooks'
import { LifeInput } from '../inputs/LifeInput'

type Props = {
  fieldNamePrefix: ValidatedKey
}

export const AddressLinkFields = ({ fieldNamePrefix }: Props) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const AddressFields = useComponent('pages.personEntity.forms.AddressFields')

  const addressTypes = useHook('fetchers.crm.useCrmAddressTypes')()

  const validateKey =
    typeUtils.createNestedValidator<AddressLink>(fieldNamePrefix)

  const [{ value: addressType }] = useField(validateKey('addressType'))

  return (
    <>
      <LifeInput
        fallbackInputType="string"
        name={validateKey('addressType')}
        label={translate('addressLink.field.addressType')}
        options={addressTypes}
        renderFn={(x) => translateEnum('legalEntity.enum.AddressType', x)}
      />
      {addressType && (
        <AddressFields fieldNamePrefix={validateKey('address')} />
      )}
    </>
  )
}
